import { Tag, TagColor } from '@factorialco/deprecated-design-system'
import { NewColor } from '@factorialco/f0-react'
import {
  AtsApplicationPhaseTagFragment,
  AtsHiringStageNamesEnum,
} from 'generated/resources/graphql'

interface Props {
  applicationPhase: AtsApplicationPhaseTagFragment
}

export const phaseColor = (status: AtsHiringStageNamesEnum | 'default') => {
  const statusColors: Record<AtsHiringStageNamesEnum | 'default', NewColor> = {
    new: 'purple',
    screening: 'viridian',
    interview: 'yellow',
    assessment: 'barbie',
    offer: 'malibu',
    hired: 'flubber',
    default: 'smoke',
  }

  return statusColors[status]
}

/* TODO: replace by Tag component from Factorial-One
 * use phaseColor instead of statusColors
 */
export const ApplicationPhaseTag = ({ applicationPhase }: Props) => {
  const hiringStageToColor: Record<string, TagColor> = {
    new: TagColor.lime,
    screening: TagColor.viridian,
    interview: TagColor.champagne,
    assessment: TagColor.radical,
    offer: TagColor.purple,
    hired: TagColor.malibu,
    default: TagColor.grey,
  }

  return (
    <Tag
      inline
      type={
        hiringStageToColor[applicationPhase.hiringStage?.name || 'default'] ||
        hiringStageToColor.default
      }
    >
      {applicationPhase.name}
    </Tag>
  )
}
